var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWater75PercentIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 15.4998C5.5 19.0798 8.42 21.9998 12 21.9998H12.02C15.6 21.9998 18.52 19.0798 18.52 15.4998C18.52 14.5498 18.25 13.3498 17.81 12.2798C16.6642 9.52988 13.148 3.86249 12.6934 3.12982C12.6719 3.09516 12.6572 3.07155 12.65 3.0598L12.01 2.0498L11.37 3.0598C11.21 3.3098 7.4 9.3998 6.21 12.2798C5.76 13.3598 5.5 14.5598 5.5 15.4998ZM7.59 12.8598C8.45 10.7798 10.85 6.7798 12 4.8898C13.16 6.7798 15.55 10.7798 16.41 12.8598C16.69 13.5498 17 14.6098 17 15.4998C17 18.2598 14.76 20.4998 12 20.4998C9.24 20.4998 7 18.2598 7 15.4998C7 14.6098 7.3 13.5498 7.59 12.8598ZM8.9 13.72C9.09 13.25 9.4 12.64 9.75 12H14.25C14.6 12.65 14.91 13.26 15.1 13.72C15.31 14.23 15.5 14.91 15.5 15.5C15.5 17.43 13.93 19 12 19C10.07 19 8.5 17.43 8.5 15.5C8.5 14.91 8.69 14.23 8.9 13.72Z",
    fill: "#161616"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWater75PercentIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Water75_percent_icon.aefd697477d4cf19805d832f3ce4be9f.svg";